import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import {
    Blocker,
    LoadBlockerService,
} from 'bkng';

import { EnvService } from '@s/env.service';

import { ICampaign } from '@amt/i-campaign';
import { CampaignService } from '@s/campaign.service';
import { IEnv } from '@alt/i-env';
import { CampaignGetResult } from '@api-routes/campaign/types/campaign-get-result';

@Component({
    selector: 'app-crowdfund-sign-up',
    templateUrl: './crowdfund-sign-up.component.html',
    styleUrls: ['./crowdfund-sign-up.component.scss']
})
export class CrowdfundSignUpComponent implements OnInit {
    campaign: ICampaign;
    clearedToLoad: boolean = false;
    data: CampaignGetResult;
    env: IEnv;
    loadBlocker: Blocker;

    constructor (
        public envService: EnvService,
        public lbs: LoadBlockerService,
        public route: ActivatedRoute,
        public campaignService: CampaignService,
    ) {
        this.env = envService.data;
        this.loadBlocker = lbs.register({});

        this.fetch().catch(console.error).finally(() => {
            setTimeout(() => {
                this.loadBlocker.unblock();
                this.clearedToLoad = true;
            });
        });
    }

    fetch (): Promise<void> {
        return this.campaignService.getById({
            id: this.env.campaign.id,
        }).then((res) => {
            Object.assign(this, res);
            if (this.env.mode !== 'production') {
                console.log("CrowdfundSignUpComponent:", res);
            }
            this.data = res;
            return Promise.resolve();
        });
    }

    ngOnInit (): void {
    }

}
